function showNotification(type, message) {
    var icons = {
        danger: 'ban',
        info: 'info-circle',
        success: 'check'
    }
    $notifications.innerHTML = "";
    var $el = document.createElement('div');
    $el.className = 'alert alert-' + type;
    $el.role = 'alert';
    $el.innerHTML += `<div class="icon-container"><i class="fa fa-${icons[type]}"></i></div>`;
    $el.innerHTML += `<span>${message}</span>`;
    $notifications.innerHTML = $el.outerHTML;
    window.scrollTo(0, 0);
}

function clearNotification() {
    $notifications.innerHTML = "";
}

function getQueryVariable(variable) {
       var query = encodeURI(window.location.search.substring(1));
       var vars = query.split("&");
       for(var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if(pair[0] == variable) {
                return pair[1];
            }
       }
       return false;
}
